const bankAccount = {
   _id: '',
   holder: 'sameHolder',
   holderName: '',
   type: 'pf',
   document: '',
   bank: '',
   bankName: '',
   agency: '',
   agencyDigit: '',
   account: '',
   accountDigit: '',
   accountType: '',
   operation: '',
   legalRepresentative: {
      motherName: ''
   },
   monthlyIncomeOrRevenue: 0.00,
   companyOwnerCpf: '',
   companyType: '',
   cnae: '',
   establishmentDate: '',
   companyMembers: [

   ]
}

export default bankAccount;
